import { PoolHealth, PoolTier } from '@/services/preferredPoolsAPI';

// Design tokens from ui-prototype/preferred-worker-pool (handoff.html §tokens):
// TIER_COLORS / HEALTH_COLORS constant maps, ported verbatim. The server is
// authoritative for a pool's health value (PreferredPools::Health) — these
// only translate it to color.
export const TIER_COLORS: Record<PoolTier, string> = {
  platinum: '#96A7BA',
  gold: '#A28812',
  standard: '#2169BA',
  monitored: '#CF040C',
};

export const HEALTH_COLORS: Record<PoolHealth, string> = {
  red: '#CF040C',
  amber: '#ECA300',
  green: '#44A735',
};

export const NEUTRAL_TIER_COLOR = '#979797';

// Prototype barHeight() — clamps so a 0-member pool still shows a nub.
export const barHeight = (count: number): number =>
  Math.max(10, Math.min(44, 8 + count * 4.5));

export const SOURCE_LABELS: Record<string, string> = {
  client_nomination: 'Client nomination',
  system_suggestion: 'System suggestion',
  manual: 'Manual add',
};
